import React from 'react'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import { get } from 'client/utils/api-routes.util'
import {
  DcBreadcrumbs,
  DcFlexBox,
  PixelPageContainer,
  Section,
  SectionContent,
} from 'pixel-base'

import { CompanyInfo } from './comp/CompanyInfo'
import { Subscriptions } from './comp/Subscriptions'

const breadcrumbs = [
  {
    name: 'Settings',
    active: false,
  },
  {
    name: 'General Info',
    active: true,
  },
]

const General = () => {
  const [countries, setCountries] = React.useState([])
  React.useEffect(() => {
    getAllCountries()
  }, [])
  const getAllCountries = () => {
    get('/settings/options/countries').subscribe((res: any) => {
      setCountries(
        res.response.data.map((e) => {
          return {
            value: e.two_letter_abbreviation,
            label: e.name,
            two_letter_abbreviation: e.two_letter_abbreviation,
          }
        }),
      )
    })
  }

  return (
    <>
      <PixelPageContainer
        height="100vh"
        style={{ padding: '0px', maxHeight: '100vh' }}
      >
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              height="60px"
              fontSize="16px"
              style={{ fontSize: '16px', padding: '8px 16px' }}
            >
              <DcFlexBox
                justifyContent="space-between"
                alignItems="center"
                padding=".5rem 20px"
              >
                <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

                <ProfileSection />
              </DcFlexBox>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <DcFlexBox
          height="calc(100vh - 60px)"
          style={{ overflow: 'auto' }}
          flexDirection="column"
          gap="20px"
        >
          <CompanyInfo countries={countries} />
          <Subscriptions />
        </DcFlexBox>
      </PixelPageContainer>
    </>
  )
}

export default General
